export const globalConstants = {
    IMPORT_DOCUMENT: 7,// MB.
};